import { sendGoogleEvent } from '@html/_common/utils';

export default function SerpContactSection() {
  this.initiate = () => {
    const CONTACT_SECTION_SELECTOR = '.js-contact-section__content-contact-box--button';

    $(document).on('click', CONTACT_SECTION_SELECTOR, () => {
      import(/* webpackChunkName: "AskAQuestion" */'@html/_common/question/script').then((module) => {
        const AskAQuestion = module.default;
        const question = new AskAQuestion();

        question.startEnquiryDialog({
          id: -1,
          name: `SERP - ${window.location.pathname.substring(1)}`,
          forceEnquiry: true,
        });

        sendGoogleEvent(
          'Contact Us',
          'Something else - Traveller',
          'Send a message',
          {
            ampEventName: 'ask_question_form_opened',
          },
        );
      });
    });
  };
}
